export const stripNonNumericCharacters = (value: string): string => value.replace(/[^\d.-]/g, '');
